module.exports = __webpack_public_path__ + "static/media/favActive.57a6e3bc.svg";